import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "auth-flow",
      component: () => import("./views/shared/Auth.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/shared/Login.vue")
    },
    {
      path: "/login/callback",
      name: "login-callback",
      component: () => import("./views/shared/Auth.vue")
    },
    {
      path: "/admin",
      name: "admin-login",
      component: () => import("./views/shared/Login.vue")
    },
    {
      path: "/admin/dashboard",
      name: "admin-dashboard",
      component: () => import("./views/admin/dashboard/Index.vue")
    },
    {
      path: "/admin/contracts",
      name: "admin-contracts",
      component: () => import("./views/admin/companies/Index.vue")
    },
    {
      path: "/admin/companies",
      name: "admin-companies",
      component: () => import("./views/admin/companies/CompanyList.vue")
    },
    {
      path: "/admin/companies/add",
      name: "admin-companies-add",
      component: () => import("./views/admin/companies/Add.vue")
    },
    {
      path: "/admin/companies/new-company",
      name: "admin-companies-new-company",
      component: () => import("./views/admin/companies/NewCompany.vue")
    },
    {
      path: "/admin/companies/:id/update",
      name: "admin-companies-edit",
      component: () => import("./views/admin/companies/NewCompany.vue")
    },
    {
      path: "/admin/companies/new-contract",
      name: "admin-companies-new-contract",
      component: () => import("./views/admin/companies/NewContract.vue")
    },
    {
      path: "/admin/contracts/:id/update",
      name: "admin-contracts-edit",
      component: () => import("./views/admin/companies/Add.vue")
    },
    {
      path: "/admin/contracts/:id/subscritors",
      name: "admin-companies-subscritors",
      component: () => import("./views/admin/companies/Subscriptors.vue")
    },
    {
      path: "/admin/contracts/:id/currencies",
      name: "admin-companies-currencies",
      component: () => import("./views/admin/companies/Currencies.vue")
    },
    {
      path: "/admin/contracts/:id/exclusions",
      name: "admin-companies-exclusions",
      component: () => import("./views/admin/companies/Exclusions.vue")
    },
    {
      path: "/admin/contracts/:id/limits",
      name: "admin-companies-limits",
      component: () => import("./views/admin/companies/Limits.vue")
    },
    {
      path: "/admin/reinsurers",
      name: "reinsurers",
      component: () => import("./views/admin/reinsurers/Index.vue")
    },
    {
      path: "/admin/users",
      name: "admin-user",
      component: () => import("./views/admin/users/Index.vue")
    },
    {
      path: "/admin/users/:id/contracts",
      name: "admin-user-contracts",
      component: () => import("./views/admin/users/UserContracts.vue")
    },
    {
      path: "/admin/exchanges",
      name: "admin-exchange",
      component: () => import("./views/admin/exchanges/Index.vue")
    },
    {
      path: "/admin/generals",
      name: "admin-generals",
      component: () => import("./views/admin/generals/Index.vue")
    },
    {
      path: "/admin/control-zones",
      name: "admin-control-zones",
      component: () => import("./views/admin/controlzones/Index.vue")
    },
    {
      path: "/admin/batches",
      name: "admin-batches",
      component: () => import("./views/admin/batches/BatchList.vue")
    },
    {
      path: "/admin/batches/new",
      name: "admin-batches-new",
      component: () => import("./views/admin/batches/BatchForm.vue")
    },
    {
      path: "/admin/batches/:id",
      name: "admin-batches-form",
      component: () => import("./views/admin/batches/BatchForm.vue")
    },
    {
      path: "/admin/requests",
      name: "admin-requests",
      component: () => import("./views/admin/requests/Index.vue")
    },
    {
      path: "/admin/requests/:id/details",
      name: "admin-requests-details",
      component: () => import("./views/admin/requests/Details.vue")
    },
    {
      path: "/admin/claims",
      name: "admin-claims",
      component: () => import("./views/admin/claims/Index.vue")
    },
    {
      path: "/admin/claims/:id/details",
      name: "admin-claims-details",
      component: () => import("./views/admin/claims/Details.vue")
    },
    {
      path: "/admin/claimspayments",
      name: "admin-claimspayments",
      component: () => import("./views/admin/claimspayments/Index.vue")
    },
    {
      path: "/admin/claimspayments/:id/details",
      name: "admin-claimspayments-details",
      component: () => import("./views/admin/claimspayments/Details.vue")
    },
    {
      path: "/admin/requests/endorsments-without-movement",
      name: "admin-endorsments-without-movement",
      component: () => import("./views/admin/requests/Index.vue")
    },
    {
      path: "/admin/requests/endorsments-with-movement",
      name: "admin-endorsments-with-movement",
      component: () => import("./views/admin/requests/Index.vue")
    },
    {
      path: "/admin/control-zones-requests-report",
      name: "admin-control-zones-requests-report",
      component: () => import("./views/admin/requests/ControlZonesReport.vue")
    },
    {
      path: "/dashboard",
      name: "client-dashboard",
      component: () => import("./views/client/dashboard/Index.vue")
    },
    {
      path: "/seleccionar-empresa",
      name: "client-seleccionar-empresa",
      component: () => import("./views/client/seleccionarEmpresa/Index.vue")
    },
    {
      path: "/facility/select",
      name: "client-select-facility",
      component: () => import("./views/client/facility/Index.vue")
    },
    {
      path: "/facility/dashboard",
      name: "client-facility-dashboard",
      component: () => import("./views/client/facility/dashboard/FacilityDashboard.vue")
    },
    {
      path: "/requests",
      name: "client-requests",
      component: () => import("./views/client/requests/NewRequest/Index.vue")
    },
    {
      path: "/requests/new-request/conditions",
      name: "client-requests-new-request-conditions",
      component: () =>
        import("./views/client/requests/NewRequest/Condiciones.vue")
    },
    {
      path: "/requests/new-request/aeronavegacion",
      name: "client-requests-new-request-aeronavegacion",
      component: () =>
        import("./views/client/requests/NewRequest/Aeronavegacion.vue")
    },
    {
      path: "/requests/new-request/automovil-flota",
      name: "client-requests-new-request-automovil-flota",
      component: () =>
        import("./views/client/requests/NewRequest/AutomovilFlota.vue")
    },
    {
      path: "/requests/new-request/automovil-ovp",
      name: "client-requests-new-request-automovil-ovp",
      component: () =>
        import("./views/client/requests/NewRequest/AutomovilOvp.vue")
    },
    {
      path: "/requests/new-request/otros",
      name: "client-requests-new-request-otros",
      component: () => import("./views/client/requests/NewRequest/Otros.vue")
    },
    {
      path: "/requests/:id/details",
      name: "client-requests-details",
      component: () => import("./views/client/requests/Details.vue")
    },
    {
      path: "/requests/:id/endorsment/:modifyType",
      name: "client-requests-endorsment-complex",
      component: () => import("./views/client/requests/Details.vue")
    },
    {
      path: "/requests/:id/edit-insured",
      name: "client-requests-modificar-asegurados",
      component: () => import("./views/client/requests/ModificarAsegurados.vue")
    },
    {
      path: "/requests/process-requests",
      name: "client-process-requests",
      component: () => import("./views/client/requests/Index.vue")
    },
    {
      path: "/requests/endorsments-without-movement",
      name: "client-endorsments-without-movement",
      component: () => import("./views/client/requests/Index.vue")
    },
    {
      path: "/requests/endorsments-with-movement",
      name: "client-endorsments-with-movement",
      component: () => import("./views/client/requests/Index.vue")
    },
    {
      path: "/requests/quotes",
      name: "client-requests-quotes",
      component: () => import("./views/client/requests/list/quotes/Index.vue")
    },
    {
      path: "/requests/bordereaux",
      name: "client-requests-bordereaux",
      component: () => import("./views/client/requests/list/bordereaux/Index.vue")
    },
    {
      path: "/requests/:id/detail",
      name: "client-requests-detail",
      component: () => import("./views/client/requests/detail/RequestDetail.vue")
    },
    {
      path: "/requests/:id/quote",
      name: "client-requests-quote",
      component: () => import("./views/client/requests/quote/fire/QuoteRequest.vue")
    },
    {
      path: "/requests/new",
      name: "client-requests-new-select-branch",
      component: () => import("./views/client/requests/new/select-branch/NewRequestSelectBranch.vue")
    },
    {
      path: "/requests/new/conditions",
      name: "client-requests-new-conditions",
      component: () =>
        import("./views/client/requests/new/conditions/NewRequestConditions.vue")
    },
    {
      path: "/requests/new/form",
      name: "client-requests-new-request-fire",
      component: () => import("./views/client/requests/new/data/NewRequestData.vue")
    },
    {
      path: "/usuario",
      name: "client-usuario",
      component: () => import("./views/client/usuario/Index.vue")
    },
    {
      path: "/claims",
      name: "client-new-claim",
      component: () =>
        import("./views/client/claims/NewClaim/SelectRequest.vue")
    },
    {
      path: "/claims/new-claim/fill-claim-data",
      name: "client-claims-compilar-datos",
      component: () =>
        import("./views/client/claims/NewClaim/FillClaimData.vue")
    },
    {
      path: "/claims/process-claims",
      name: "client-process-claims",
      component: () => import("./views/client/claims/Index.vue")
    },
    {
      path: "/claims/:id/details",
      name: "client-claims-details",
      component: () => import("./views/client/claims/Details.vue")
    },
    {
      path: "/claims/:id/edit-insured",
      name: "client-claims-modificar-asegurados",
      component: () => import("./views/client/claims/ModificarAsegurados.vue")
    },
    {
      path: "/requests/file-upload",
      name: "client-requests-filesUpload",
      component: () => import("./views/client/requests/fileUpload.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  document.body.classList.remove("scroll-lock");
  const $store = JSON.parse(localStorage.getItem("aon-app"));
  const isClient = to.name.split("-")[0] === "client";

  if (to.name !== "login" && to.name !== "auth-flow" && to.name !== "login-callback") {
    if ($store && $store.user && $store.user.id) {
      if (($store.user.type === 1 || $store.user.type === 2) && isClient) {
        (window as any).location = "/admin/dashboard";
      } else if (
        !($store.user.type === 1 || $store.user.type === 2) &&
        !isClient
      ) {
        (window as any).location = "/dashboard";
      }
    }
  }

  next();
});

export default router;
